module.exports = __webpack_public_path__ + "static/media/icn_thumbs_up.30f92f7f.svg";